import userClient from '../config/api/userClient';
var lastMessageUrl = "pubdesk/system/latestmessage";
export var getLastUpdateData = function () {
    return userClient.get(lastMessageUrl);
};
